<template>
        <div
            class="auth__intro__container">
            <video
                ref="videoIntro"
                class="auth__intro__video"
                :poster="intro.firstPage.background.url">
                <source :src="intro.secondPage.backgroundMp4Url" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <div
                v-if="page == 1"
                class="auth__intro__container__fullscreen">
                <div
                    class="auth__intro__container__fullscreen__content">
                    <div class="text-center">
                        <img :src="intro.firstPage.logo.url" alt="">
                        <div class="flex justify-center mt-8">
                            <button
                                type="button"
                                class="auth__intro__cta__button cursor-pointer"
                                :style="{
                                    backgroundColor: intro.firstPage.buttonColor,
                                }"
                                @click="next">
                                <span>Commencer</span>
                                <img src="@/assets/intro-play.png" alt="" class="">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else-if="page == 2"
                class="auth__intro__container__description p-10">
                <img :src="intro.secondPage.logo.url" alt="" class="mb-10">
                <h2 v-html="intro.secondPage.title.replace(/\n/g, '<br />')"/>
                <p v-html="intro.secondPage.text.replace(/\n/g, '<br />')" class="mt-10"/>
                <div class="flex justify-center my-8">
                    <button
                        type="button"
                        class="auth__intro__cta__button final cursor-pointer"
                        :style="{
                            backgroundColor: intro.firstPage.buttonColor,
                        }"
                        @click="next">
                        <span>Étape suivante</span>
                        <img src="@/assets/intro-goto-signin.png" alt="" class="">
                    </button>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    props: {
        intro: Object,
    },
    data() {
        return {
            page: 1,
        }
    },
    methods: {
        next() {
            this.page++;

            this.$emit('next');

            if (this.page == 2) {
                setTimeout(() => {
                    this.$refs.videoIntro.play();
                }, 10);
            } else if (this.page == 3) {
                this.$emit('toggleIntro');
            }
        }
    },
}
</script>